import { BaseThumbnail } from "../BaseThumbnail";
import { AssetLayering } from "views/page-content/cloud/upload/types";
import { UppyFile } from "@uppy/core";
import AudioAssetPlaceholder from "assets/icons/audio-placeholder.svg?react";
import { Spinner } from "components/spinners/Spinner";
import styles from "./index.module.scss";

export interface AssetUploadThumbnailProps {
    assetFile: UppyFile;
    selectedAspectRatio: string;
    assetLayering: AssetLayering;
    previewUrl?: string | null;
    isLoading?: boolean;
}

export const AssetUploadThumbnail = ({
     previewUrl,
     isLoading
 }: AssetUploadThumbnailProps) => {
    return isLoading ? (
        <div className={styles["loading"]}>
            <Spinner />
        </div>
    ) : (
        <BaseThumbnail>
            {!previewUrl ? (
                <AudioAssetPlaceholder className={styles["audio-placeholder"]} />
            ) : (
                <img src={previewUrl} alt="Asset Thumbnail" />
            )}
        </BaseThumbnail>
    );
};